export default "__VITE_ASSET__CcIL8ZQU__"